import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

interface IAirportSelectorWidgetProps {
  airports: string[];
  selectedAirport: string;
  onChange: (airport: string) => void;
}

export const AirportSelectorWidget = ({
  airports,
  selectedAirport,
  onChange,
}: IAirportSelectorWidgetProps) => {
  if (airports.length <= 1) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        mb: 2,
        mt: -2,
        background: "linear-gradient(to right, #f8fafc, #e2e8f0)",
        padding: 1.2,
        borderRadius: 1
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: "text.primary", whiteSpace: "nowrap" }}
      >
        Select Airport
      </Typography>
      <ToggleButtonGroup
        value={selectedAirport}
        exclusive
        onChange={(_, value) => value && onChange(value)}
        size="small"
        aria-label="airport selector"
        sx={{
          "& .MuiToggleButton-root": {
            px: 2,
            py: 0.8,
            fontSize: "0.8rem",
            fontWeight: 500,
            textTransform: "none",
            color: "#64748b",
            background: "#fff",
            borderColor: "#d3dbe8",
            "&.Mui-selected": {
              backgroundColor: "#10559a",
              color: "#fff",
              borderColor: "#10559a",
              "&:hover": {
                backgroundColor: "#0d4a8a",
              },
            },
          },
        }}
      >
        {airports.map((airport) => (
          <ToggleButton key={airport} value={airport}>
            {airport}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};
